// extracted by mini-css-extract-plugin
export var content = "_oo-1";
export var fullScreen = "_oo-0";